// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import { EditableComponent, EditableComponentProps } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';

// Use named rather than default exports.
import { AccountPartnerCardWrapperProps } from './AccountPartnerCardWrapper.types';
const AccountPartnerCardWrapper = dynamic(() =>
  import('./AccountPartnerCardWrapper').then(mod => mod.AccountPartnerCardWrapper)
);

export const AccountCardWrapperConfig = {
  emptyLabel: 'partnercardwrapper',
  isEmpty: () => true,
  resourceType: `mi-aem-account/components/content/partnercardwrapper`,
};

type editableCompAccountPartnerCardWrapperProps = EditableComponentProps & AccountPartnerCardWrapperProps;

export const AccountPartnerCardWrapperEditable = (props: editableCompAccountPartnerCardWrapperProps) => (
  // editable component export
  <EditableComponent config={AccountCardWrapperConfig} {...props}>
    <AccountPartnerCardWrapper {...props} />
  </EditableComponent>
);
